// extracted by mini-css-extract-plugin
export var cardIcon = "_92-5";
export var checkboxCard = "_92-0";
export var checkboxCardSelected = "_92-4";
export var disabled = "_92-2";
export var interactive = "_92-1";
export var outerBorder = "_92-3";
export var spacerMedium = "_92-8";
export var spacerSmall = "_92-7";
export var spacerXsmall = "_92-6";